 export const downloadBase64Pdf=(base64String, fileName) =>{
    try {
      console.log(fileName)
      const cleanedBase64String = base64String.replace(/^data:application\/pdf;base64,/, "");
      const byteCharacters = atob(cleanedBase64String);
      const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
  
      const blobUrl = URL.createObjectURL(blob);
  
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
  
      link.click();
  
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Failed to download PDF:", error.message);
    }
  }